import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://swasthgram.onrender.com',
    timeout: 10000,
});

// Request interceptor for logging
instance.interceptors.request.use(
    config => {
        console.log('Axios Request:', config.url, config.headers); // Debug log
        return config;
    },
    error => Promise.reject(error),
);

export default instance;